import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';

import { baseObj } from './actions/base';
import { orderObj } from './actions/order';
import { getQueryStringByName } from '@/utils/helper';
import { device } from './actions/device';
import { adapter } from './actions/adapter';
import { sideBar } from './actions/sideBar';
import { channel } from './actions/channel';
import { filmInfo } from './actions/filmInfo';
import { switchConfig } from './actions/switch';
import { routerHistory } from './actions/routerHistory';
import { StoreType } from '@/types';
import { cinemaCurrencySign } from './actions/cinemaCurrencySign';
let store: any = (set, get) => ({
  // 可持久化的状态
  ...baseObj(set), // 基础信息
  ...orderObj(set, get), // 订单信息
  ...device(set), // 设备信息 h5/pad/pc
  ...adapter(set), // 适配信息
  ...sideBar(set), // 侧边栏
  ...channel(set), // 渠道信息，英皇、博纳、银河、ACX
  ...filmInfo(set, get), // 影院信息
  ...switchConfig(set, get), // 渠道配置信息
  ...routerHistory(set), // 历史路由记录
  ...cinemaCurrencySign(set, get), // 影院币种符号
  isLoading: true,
  setLoading(flag) {
    set({
      isLoading: flag,
    });
  },
});

// persist the created state
store = persist(store, {
  name: `${getQueryStringByName('wapid')}_baseObj`,
  // 指定持久化哪些部分
  partialize: (state: any) => ({
    baseObj: state.baseObj,
  }),
});

// add the devtools
store = devtools(store);

// create the store
const useStore: StoreType = create(store);

export { useStore };
